import { render, staticRenderFns } from "./LearningNow.vue?vue&type=template&id=cf546a50&scoped=true&"
import script from "./LearningNow.vue?vue&type=script&lang=js&"
export * from "./LearningNow.vue?vue&type=script&lang=js&"
import style0 from "./LearningNow.vue?vue&type=style&index=0&id=cf546a50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf546a50",
  null
  
)

export default component.exports